import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import classNames from 'classnames';
import './OptinCta.scss';

export default function CtaOptin(props) {
  const ctaBox = classNames('cta-box', props.ctaBox);
  const outerColor = classNames('cta-box-rounded p-sm-3 text-center text-white', props.outerColor);
  const innerColor = classNames('cta-box-rounded px-3 py-4', props.innerColor);
  return (
    <div className={ctaBox}>
      <Container>
        <Row>
          <Col className="px-0 px-sm-3">
            <div className={outerColor}>
              <div className={innerColor}>
                {props.children}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
